"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoritesRepositoryLocalStorageImpl = void 0;
const yup_1 = require("yup");
const Yup = { object: yup_1.object, string: yup_1.string };
const productItemSkuSchema = Yup.object({
    sku: Yup.string().trim().required(),
});
function mapToProductItemSku(item) {
    return { sku: item.sku };
}
class FavoritesRepositoryLocalStorageImpl {
    constructor(storageKey, limit) {
        this.storageKey = storageKey;
        this.limit = limit;
        this.strategyName = 'localStorage';
    }
    getAllItems() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const fromStorage = localStorage.getItem(this.storageKey);
                const parsedItemsFromStorage = JSON.parse(fromStorage || '[]');
                if (Array.isArray(parsedItemsFromStorage)) {
                    const validItems = parsedItemsFromStorage.filter((item) => productItemSkuSchema.isValidSync(item));
                    const hasInvalidItems = validItems.length !== parsedItemsFromStorage.length;
                    if (hasInvalidItems) {
                        console.warn('Some favorite items are invalid. Restoring only the valid ones...');
                    }
                    return validItems.map(mapToProductItemSku);
                }
                else {
                    throw new Error('Invalid data from storage');
                }
            }
            catch (err) {
                const emptyList = [];
                yield this.persistItems(emptyList);
                return emptyList;
            }
        });
    }
    addItems(products) {
        return __awaiter(this, void 0, void 0, function* () {
            const favorites = yield this.getAllItems();
            const updatedItems = products.map(({ sku }) => ({ sku })).concat(favorites);
            yield this.persistItems(updatedItems);
            return updatedItems;
        });
    }
    removeItem(product) {
        return __awaiter(this, void 0, void 0, function* () {
            const favorites = yield this.getAllItems();
            const updatedItems = favorites.filter((item) => item.sku !== product.sku);
            yield this.persistItems(updatedItems);
            return updatedItems;
        });
    }
    isFull() {
        return __awaiter(this, void 0, void 0, function* () {
            const favorites = yield this.getAllItems();
            return favorites.length >= this.limit;
        });
    }
    clearItems() {
        return __awaiter(this, void 0, void 0, function* () {
            localStorage.removeItem(this.storageKey);
        });
    }
    persistItems(items) {
        return __awaiter(this, void 0, void 0, function* () {
            const areItemsValid = items.every((item) => productItemSkuSchema.isValidSync(item));
            try {
                if (areItemsValid) {
                    localStorage.setItem(this.storageKey, JSON.stringify(items.map(mapToProductItemSku)));
                }
                else {
                    throw new Error('Invalid favorite items');
                }
            }
            catch (err) {
                const validItems = items.filter((item) => productItemSkuSchema.isValidSync(item));
                localStorage.setItem(this.storageKey, JSON.stringify(validItems.map(mapToProductItemSku)));
            }
        });
    }
}
exports.FavoritesRepositoryLocalStorageImpl = FavoritesRepositoryLocalStorageImpl;
